import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { Technology } from './pages/Technology';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rk47n7gir6il">
      <ScrollToTop data-id="element-1" data-mp="2rlox4inz7z9l" />
      <div className="flex min-h-screen w-full flex-col bg-canvas font-sans" data-id="element-2" data-mp="2rit14zvovkns">
        <Header data-id="element-3" data-mp="2mndqegsza4vl" />
        <div className="flex-1" data-id="element-4" data-mp="2mjpuxc3z38e8">
          <Routes data-id="element-5" data-mp="31agoopp4khjz">
            <Route path="/" element={<Home data-id="element-7" data-mp="31c9uy3vtszrg" />} data-id="element-6" data-mp="31ayplzmqfjy8" />
            <Route path="/shop" element={<Shop data-id="element-9" data-mp="2wk9zanmsgt0o" />} data-id="element-8" data-mp="31ctf7r8y808n" />
            <Route path="/technology" element={<Technology data-id="element-11" data-mp="2wip7h5ruzo6i" />} data-id="element-10" data-mp="2wiyxuugtfxcq" />
            <Route path="/contact" element={<Contact data-id="element-13" data-mp="28tmi1bqzgr1g" />} data-id="element-12" data-mp="28ufoscpxzgjl" />
            <Route path="*" element={<Home data-id="element-15" data-mp="28s2y9b64bxux" />} data-id="element-14" data-mp="28suveqfd63nb" />
          </Routes>
        </div>
        <Footer data-id="element-16" data-mp="23u9vyt7xrnzx" />
      </div>
    </BrowserRouter>;
}